// extracted by mini-css-extract-plugin
export default {"container":"style_container__l2juW","header":"style_header__OMglD","contentContainer":"style_contentContainer__1YD8d"};